/** 閲覧申請：見送り理由 稼働の調整 */
export const VIEW_REQUEST_PROPOSAL_SEND_OFF_REASON_WORK = {
    label: '稼働の調整',
    placeholder: '現在プロジェクトメンバーの稼働が不足しているため、本件は辞退させていただきます。',
    value: 1,
};
/** 閲覧申請：見送り理由 予算の問題 */
export const VIEW_REQUEST_PROPOSAL_SEND_OFF_REASON_PRICE = {
    label: '予算の問題',
    placeholder: '予算内では、成果を出すのに十分な体制・期間でご提案することが難しいと判断したため、本件は辞退させていただきます。',
    value: 2,
};
/** 閲覧申請：見送り理由 テーマの専門性 */
export const VIEW_REQUEST_PROPOSAL_SEND_OFF_REASON_THEME = {
    label: 'テーマの専門性',
    placeholder: 'プロジェクト推進に必要な専門知識を持つメンバーを確保することが出来ないため、本件は辞退させて頂きます。',
    value: 3,
};
/** 閲覧申請：見送り理由 その他の理由 */
export const VIEW_REQUEST_PROPOSAL_SEND_OFF_REASON_OTHER = {
    label: 'その他の理由',
    placeholder: '辞退理由を記載ください',
    value: 4,
};
/** 閲覧申請：見送り理由の一覧 */
export const VIEW_REQUEST_PROPOSAL_SEND_OFF_REASONS = [
    VIEW_REQUEST_PROPOSAL_SEND_OFF_REASON_WORK,
    VIEW_REQUEST_PROPOSAL_SEND_OFF_REASON_PRICE,
    VIEW_REQUEST_PROPOSAL_SEND_OFF_REASON_THEME,
    VIEW_REQUEST_PROPOSAL_SEND_OFF_REASON_OTHER,
];
